import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { API } from '../../config';
import styles from './EnrolledCourses.module.css';
import { Link } from 'react-router-dom';
import { FaBookOpen, FaLaptopCode, FaChartLine, FaFlask, FaBrain, FaPalette, FaGlobe, FaBullhorn } from 'react-icons/fa';

// Helper function to assign an icon and color based on a simple hash of the title
const getCourseVisuals = (title) => {
  const icons = [FaBookOpen, FaLaptopCode, FaChartLine, FaFlask, FaBrain, FaPalette, FaGlobe, FaBullhorn];
  const colors = [
    '#4f46e5', // Indigo
    '#10b981', // Emerald
    '#f97316', // Orange
    '#ef4444', // Red
    '#0ea5e9', // Sky
    '#be185d', // Rose
    '#6366f1', // Indigo again (for more options if needed)
    '#ca8a04', // Amber
  ];

  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash = title.charCodeAt(i) + ((hash << 5) - hash);
  }
  const iconIndex = Math.abs(hash) % icons.length;
  const colorIndex = Math.abs(hash + 7) % colors.length; // Offset hash for color variety

  return {
    icon: React.createElement(icons[iconIndex]),
    color: colors[colorIndex],
  };
};


const EnrolledCourses = () => {
  const user = useContext(UserContext);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    const fetchPages = async () => {
      const res = await fetch(`${API.BASE}/get-dashboard-pages.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id: user.id }),
      });
      const data = await res.json();
      if (data.success) {
        // ✅ Only show parent pages on the dashboard
        const parentPages = data.pages.filter(p => p.parent_id === null);
        setPages(parentPages);
      }
    };

    if (user.role === 'student') fetchPages();
  }, [user]);
  
  return (
    <div className={styles.container}>
      <h1 className={styles.mainHeading}>Start Learning Your Courses Here</h1>
      <div className={styles.cardGrid}>
        {pages.map((page) => (
          <Link
            to={`/view/${page.id}`}
            key={page.id}
            className={styles.card}
            style={{ '--card-main-color': page.color }}
          >
            <div className={styles.cardContent}>
              <div className={styles.iconContainer}>{page.icon}</div>
              <h4 className={styles.cardTitle}>{page.title}</h4>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default EnrolledCourses;

